import axios from 'axios';
import type {AstView} from 'rendition-core';

type CodeResult = {
    type: string;
    code: string;
};

export function partialCompile(view: AstView, nodeId: string, includeChildren: boolean, inlineSVG?: boolean) {
    return axios.post<{result: string}>('/compiler/partial-compile', {
        view: view,
        includeChildren: includeChildren,
        id: nodeId,
        inlineSVG: inlineSVG,
    });
}

export function partialCompileMultiFile(view: AstView, nodeId: string, includeChildren: boolean) {
    return axios.post<CodeResult[]>('/compiler/partial-compile-multi-file', {
        view: view,
        includeChildren: includeChildren,
        id: nodeId,
    });
}
